/** Rôles portails JCONSULT MY Academia (web). */
export const ROLE_APPRENANT = 'APPRENANT';
export const ROLE_ADMIN = 'ADMINISTRATEUR';
export const ROLE_MODERATEUR = 'MODERATEUR';
export const ROLE_FORMATEUR = 'FORMATEUR';
export const ROLE_PARTENAIRE = 'PARTENAIRE_INSTITUTIONNEL';
export const ROLE_AMBASSADEUR = 'AMBASSADEUR';

export const ADMIN_PORTAL_PREFIX = '/admin';
export const APPRENANT_PORTAL_PREFIX = '/app';
export const FORMATEUR_PORTAL_PREFIX = '/formateur';
export const PARTENAIRE_PORTAL_PREFIX = '/partenaire';
export const AMBASSADEUR_PORTAL_PREFIX = '/ambassadeur';
